import { MapPin, TrendingUp, Layers, Route } from "lucide-react";
import { SectionHeading, Reveal } from "@/components/Reveal";

const CARDS = [
  {
    icon: MapPin,
    title: "Strategic Location",
    text: "Properties located near important road and transportation corridors around Nagpur.",
    span: "lg:col-span-2",
  },
  {
    icon: TrendingUp,
    title: "Long-Term Potential",
    text: "Land can be considered for long-term investment and future development.",
    span: "",
  },
  {
    icon: Layers,
    title: "Multiple Uses",
    text: "Suitable opportunities may include residential, commercial, or investment purposes.",
    span: "",
  },
  {
    icon: Route,
    title: "Growing Connectivity",
    text: "Major road infrastructure can improve accessibility to surrounding areas.",
    span: "lg:col-span-2",
  },
];

export default function InvestmentWhy() {
  return (
    <section id="investment" data-testid="investment-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="02"
          eyebrow="The Case for Land"
          title="Why Consider Land Investment?"
          description="Land is a tangible asset in locations shaped by connectivity and planned growth. Here is what draws investors to plotted land."
        />
        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {CARDS.map((card, i) => (
            <Reveal key={card.title} delay={i * 0.08} className={card.span}>
              <div className="group h-full rounded-xl border border-gray-100 bg-background p-8 transition-colors duration-300 hover:border-gold/40 lg:p-10">
                <span className="flex h-12 w-12 items-center justify-center rounded-sm bg-navy text-gold transition-colors duration-300 group-hover:bg-gold group-hover:text-navy">
                  <card.icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="mt-6 font-display text-xl font-semibold text-navy">{card.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{card.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
